var _g, _g2, _g3, _rect, _path, _rect2, _path2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path3, _path4, _circle1, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceIntensiveMinutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 140,
    viewBox: "0 0 281 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 96C59.6731 96 74 81.6731 74 64C74 46.3269 59.6731 32 42 32C24.3269 32 10 46.3269 10 64C10 81.6731 24.3269 96 42 96Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5152 51.4366C44.9446 51.9274 43.4722 52.909 42.1961 54.0869C40.8219 52.909 39.4477 51.9274 37.8771 51.4366C32.0857 49.6697 27.1777 55.1667 27.1777 60.5654C27.1777 70.774 40.0366 81.0808 42.1961 81.0808C44.3556 81.0808 57.2145 70.8722 57.2145 60.5654C57.2145 55.1667 52.1103 49.6697 46.5152 51.4366Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 96C155.673 96 170 81.6731 170 64C170 46.3269 155.673 32 138 32C120.327 32 106 46.3269 106 64C106 81.6731 120.327 96 138 96Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.515 51.4366C140.945 51.9274 139.472 52.909 138.196 54.0869C136.822 52.909 135.448 51.9274 133.877 51.4366C128.086 49.6697 123.178 55.1667 123.178 60.5654C123.178 70.774 136.037 81.0808 138.196 81.0808C140.356 81.0808 153.215 70.8722 153.215 60.5654C153.215 55.1667 148.11 49.6697 142.515 51.4366Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 104C256.091 104 274 86.0914 274 64C274 41.9086 256.091 24 234 24C211.909 24 194 41.9086 194 64C194 86.0914 211.909 104 234 104Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.643 48.2962C237.68 48.9097 235.84 50.1367 234.245 51.6091C232.527 50.1367 230.809 48.9097 228.846 48.2962C221.607 46.0876 215.472 52.9588 215.472 59.7073C215.472 72.468 231.545 85.3514 234.245 85.3514C236.944 85.3514 253.018 72.5907 253.018 59.7073C253.018 52.9588 246.637 46.0876 239.643 48.2962Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 94L166.5 98L173.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 94L70.5 98L77.5 90",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 78,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 94,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 127,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 12,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 129.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 116.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248 124.5L252.5 137.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185 3L194 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 3.5L269 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(10 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(106 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(194 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceIntensiveMinutes);
export default __webpack_public_path__ + "static/media/persistence-intensive-minutes.e665a1010f6a2d80a74617018f67dd7f.svg";
export { ForwardRef as ReactComponent };